import { z } from "zod";

export const DrawItemSchema = z.object({
  drawItemId: z.string(),
  parentDrawItemId: z.string(),
  drawId: z.string(),
  ordinal: z.number(),
  lineRefNumber: z.string(),
  description: z.string(),
  costType: z.string(),
  custCostType: z.string(),
  budgetAmount: z.number(),
  budgetAdjustment: z.number(),
  adjustedBudget: z.number(),
  totalPriorDraw: z.number(),
  totalThisDraw: z.number(),
  netThisDraw: z.number(),
  priorDrawnToDate: z.number(),
  drawnToDate: z.number(),
  variance: z.number(),
  percentDrawn: z.number(),
  percentBudget: z.number(),
  percentInspectedThisDraw: z.number(),
  percentInspected: z.number(),
  percentInspectedPriorDraw: z.number(),
  totalRetainagePriorDraw: z.number(),
  totalReleasedPriorDraw: z.number(),
  totalRetainage: z.number(),
  totalReleased: z.number(),
  retainageBalance: z.number(),
  fundsRequired: z.number(),
  fundsAvailable: z.number(),
  projectedOver: z.number(),
  lienWaiverReceived: z.boolean(),
  finalLienWaiver: z.boolean(),
  cutChecks: z.boolean(),
  entityId: z.string(),
  totalPriorEquity: z.number(),
  totalThisEquity: z.number(),
  priorEquityToDate: z.number(),
  equityToDate: z.number(),
  totalDrawnToDate: z.number(),
  netThisDrawEquity: z.number(),
  calcPercentDraw: z.boolean(),
  predecessor: z.string().nullable(),
  flags: z.number(),
  rootItemId: z.string(),
  hccPercent: z.number(),
  initialBudget: z.number(),
  cumulativeAdjustment: z.number(),
  newItem: z.boolean(),
});

export const PortalDrawItemSchema = z.object({
  drawItemId: z.string(),
  drawId: z.string(),
  ordinal: z.number(),
  reference: z.string(),
  description: z.string(),
  costType: z.string(),
  customCostType: z.string(),
  budget: z.number(),
  budgetAdj: z.number(),
  totalBudget: z.number(),
  priorDrawLoan: z.number(),
  priorDrawEquity: z.number(),
  origDrawLoan: z.number(),
  origDrawEquity: z.number(),
  thisDrawLoan: z.number(),
  thisDrawEquity: z.number(),
  netDrawLoan: z.number(),
  netDrawEquity: z.number(),
  drawnToDateLoan: z.number(),
  drawnToDateEquity: z.number(),
  drawnToDate: z.number(),
  fundsAvail: z.number(),
  percentDrawn: z.number(),
  percentInspected: z.number(),
  thisDrawInspected: z.number(),
  priorDrawInspected: z.number(),
  projectedOver: z.number(),
});

const DrawItemHistorySchema = z.object({
  drawNumber: z.number(),
  item: DrawItemSchema,
});

export const DrawItemListSchema = z.array(DrawItemSchema);
export const DrawItemHistoryListSchema = z.array(DrawItemHistorySchema);

export type DrawItem = z.infer<typeof DrawItemSchema>;
export type DrawItemHistory = z.infer<typeof DrawItemHistorySchema>;
